export default {"src":"/_next/static/media/chevron-right.06ad7478.svg","height":20,"width":20};